import React from "react";
import { Link } from "react-router-dom";
import "./style.css";

const Navbar = () => {
  return (
    <>
      <nav className="navbar">
        <Link to="/" className="navbar-brand">
          PIA VPN Master
        </Link>
        <div className="navbar-links">
          <Link to="/privacy">Privacy Policy</Link>
        </div>
      </nav>
    </>
  );
};

export default Navbar;
